import React from "react";
import Card from "../../components/Card";

export default function StyleCard({ style, onEdit, onDelete }) {
  return (
    <Card
      title={style.nameBr}
      status={{
        label: style.enabled ? "Ativo" : "Inativo",
        color: style.enabled ? "green-400" : "disabled",
      }}
      onEdit={onEdit}
      onDelete={onDelete}
    >
      <p>{`ID: ${style.id}`}</p>
    </Card>
  );
}
